<template>
	<div
		v-if="selfservices && selfservices.length"
		:id="$vnode.key"
		class="c-block-list-selfservice-custom"
	>
		<LongReadTarget
			v-if="!accordionLevel && includeInToc"
			:container-id="$vnode.key"
			:title="'Selvbetjening'"
		/>

		<BaseH2 class="text-primary-button mb-xl" v-text="'Selvbetjening'" />

		<div
			:class="[
				'grid gap-x-layout-gutter gap-y-md',
				'grid-cols-1 >=768:grid-cols-2',
				{ '>=1024:grid-cols-3 >=1200:grid-cols-4': wideLayout },
			]"
			:style="{
				'grid-auto-rows': `1fr`,
			}"
		>
			<NuxtLinkExt
				v-for="(selfservice, index) in selfservices"
				:key="`page-${index}`"
				class="px-6"
				:to="selfservice.url"
				:target="selfservice.target"
			>
				<BaseButton tag="div" class="h-full" large>
					<template #default>
						<span v-text="selfservice.title"></span>
					</template>

					<template #icon>
						<SvgArrow />
					</template>
				</BaseButton>
			</NuxtLinkExt>
		</div>
	</div>
</template>

<script>
import LongReadTarget from '~/citi-baseline/components/LongRead/LongReadTarget';
import SvgArrow from '~/assets/svgs/icon-arrow.svg?inline';

export default {
	name: 'BlockListSelfserviceCustom',
	components: { LongReadTarget, SvgArrow },

	inject: {
		accordionLevel: {
			default: 0,
		},
	},

	inheritAttrs: false,

	props: {
		wideLayout: Boolean,
		includeInToc: Boolean,
		selfservices: {
			type: Array,
			default: () => [],
		},
	},

	data() {
		return {
			columns: 4,
		};
	},

	mounted() {
		window.addEventListener('resize', this.onResize);
		this.onResize();
	},

	beforeDestroy() {
		window.removeEventListener('resize', this.onResize);
	},

	methods: {
		onResize() {
			if (this.selfservices) {
				const { innerWidth } = window;
				this.columns = 1;
				innerWidth >= 768 && (this.columns = 2);
				innerWidth >= 1024 && this.wideLayout && (this.columns = 3);
				innerWidth >= 1200 && this.wideLayout && (this.columns = 4);

				this.columns = Math.min(this.columns, this.selfservices.length);
				this.columns =
					innerWidth >= 768
						? Math.max(this.columns, 2)
						: this.columns;
			}
		},
	},
};
</script>
